/**
 * PriMessageList — Scrollable message list with auto-scroll to bottom.
 * Renders PriMessageBubble for each message and PriTypingIndicator when loading.
 */
import { usePriStore } from '@/stores/pri-store';
import { useEffect, useRef } from 'react';
import { PriMessageBubble } from './PriMessageBubble';
import { PriTypingIndicator } from './PriTypingIndicator';

export function PriMessageList() {
  const messages = usePriStore(s => s.messages);
  const isLoading = usePriStore(s => s.isLoading);
  const bottomRef = useRef<HTMLDivElement>(null);

  // Auto-scroll to bottom when new messages arrive or loading state changes
  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages.length, isLoading]);

  return (
    <div className="flex-1 overflow-y-auto py-2">
      {messages.map(msg => (
        <PriMessageBubble key={msg.id} message={msg} />
      ))}
      {isLoading && <PriTypingIndicator />}
      <div ref={bottomRef} />
    </div>
  );
}
